module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.notifications.length > 0) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "box-layout-inner"
  }, _vm._l((_vm.notifications), function(notification) {
    return (notification.route) ? _c('router-link', {
      key: notification.id,
      staticClass: "acc-alerts",
      class: {
        'urgent': true
      },
      attrs: {
        "to": notification.route
      }
    }, [_c('i', {
      class: 'fa ' + notification.icon
    }), _vm._v(" "), _c('span', {
      staticClass: "title",
      domProps: {
        "innerHTML": _vm._s(notification.description)
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-chevron-right"
    })]) : _c('a', {
      key: notification.id,
      staticClass: "acc-alerts",
      class: {
        'urgent': true
      }
    }, [_c('i', {
      class: 'fa ' + notification.icon
    }), _vm._v(" "), _c('span', {
      staticClass: "title",
      domProps: {
        "innerHTML": _vm._s(notification.description)
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-chevron-right"
    })])
  }))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33392181"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/Notifications.vue
// module id = 167
// module chunks = 0